import { ApiConfig } from "../lib/request/api-config";

export const getClothesDetailByIdApi: ApiConfig = {
  url: "/wx-api/clothing/clothes",
  method: "GET",
};
